import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {MeetingFileService} from '../../../service/info/service-meetingfile';
import {MeetingService} from '../../../service/info/service-meeting';
import {MeetingXuLyService} from '../../../service/info/service-meetingxuly';
import {MeetingFile} from '../../../models/info/meetingfile';
import {Meeting} from '../../../models/info/meeting';
import {MeetingXuLy} from '../../../models/info/meetingxuly';
import {YKienMeetingComponent} from './ykien.component';
import {Sessioncommand} from '../../../global/sessioncommand';
import {environment} from '../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  templateUrl: './detail.component.html'

})
export class DetailMeetingComponent implements OnInit, AfterViewInit {
  public language = language;
  public meetingXulyItem: MeetingXuLy = new MeetingXuLy();
  public meetingItem: Meeting = new Meeting();
  public id: number= 0;
  public meetingFiles: MeetingFile [] = [];
  public meetingXuLys: MeetingXuLy []  = [];
  public  onClose: Subject<boolean>;
  public urlExportMeeting: string = environment.exportMeeting;
  public urlPrintMeeting: string= environment.printMeeting;
  constructor(  public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public meetingFileService: MeetingFileService,
                public bsModalService: BsModalService,
                public datepipe: DatePipe,
                public _bsModalRef: BsModalRef,
                public meetingXuLyService: MeetingXuLyService,
                public meetingService: MeetingService,
                public commandUtils: CommandUtil,
                public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public edit(id: number) {
    this.id = id;
    this.meetingXuLyService.getDetailById(id).pipe(first())
      .subscribe(x => {
        this.meetingXulyItem = x;
        this.meetingFileService.findAllByMeetingId(x.maYeuCau).subscribe(
          k => {
            this.meetingFiles = k;
          });
        this.meetingService.getById(x.maYeuCau).subscribe( q => {this.meetingItem = q;
          if(q.maNguoiChuTri === Sessioncommand.staffId || q.choThamKhao === 0)
            this.showStaff(x.maYeuCau, -1);
          else
            this.showStaff(x.maYeuCau, Sessioncommand.staffId);
        });
      });


  }
  public showStaff(id: number, st: number)
  {
    this.meetingXuLyService.findByMaYeuCauAndStaffId(id, st).subscribe(
      x => {
          this.meetingXuLys = x;
      });
  }
  phatBieu(id: number) {
    const modalEdit = this.bsModalService.show(YKienMeetingComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKienMeetingComponent>modalEdit.content).edit(
      id,0
    );
    (<YKienMeetingComponent>modalEdit.content).onClose.subscribe(result => {

      this.edit(id);

    });

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

